import React from 'react';
import cc from 'classcat';
import { paymentMethodType } from 'lib/constants';
import { Typography, TypographyVariant } from 'components/Typography';
import { fundsProtectionContent, mobileContent } from './data';
import './fundsProtectionContent.css';

const fundsProtectionUrl =
  'https://www.gamblingcommission.gov.uk/guidance/customer-funds-segregation-disclosure-to-customers-and-reporting/the-customer-funds-insolvency-ratings-system';

interface FundsProtectionContentProps {
  selectedMethodType?: string;
  hasNotAcceptedTerms?: boolean;
}

const FundsProtectionContent = ({
  selectedMethodType,
  hasNotAcceptedTerms
}: FundsProtectionContentProps) => (
  <div
    className={cc([
      'fundsProtectionContent',
      { 'fundsProtectionContent--termsAccepted': !hasNotAcceptedTerms }
    ])}
  >
    {selectedMethodType === paymentMethodType.MOBILE && (
      <Typography variant={TypographyVariant.BodyXs}>
        <span>{mobileContent}</span>
      </Typography>
    )}
    <Typography variant={TypographyVariant.BodyXs}>
      <span className="fundsProtectionContent__fundsText">
        {fundsProtectionContent}
        <a
          className="fundsProtectionContent__fundsLink"
          href={fundsProtectionUrl}
          target="_blank"
          rel="noreferrer"
        >
          here.
        </a>
      </span>
    </Typography>
  </div>
);

export default FundsProtectionContent;
